module.exports = __webpack_public_path__ + "img/editor.45b30f6a.svg";